import { QBox, QMultiSelect, useCurrentUser, useToastProvider } from '@qualio/ui-components';
import React from 'react';
import { useQuery } from 'react-query';
import { getGroups } from '../../../api/medtech-api';
import { Group } from '../../../types';
import { createErrorToast } from '../../../utils/toast.utils';

type GroupsSelectorProps = {
  onSelect: (selectedGroupIds: Group[]) => void;
  selectedGroups: Group[];
};

export const GroupsSelector: React.FC<GroupsSelectorProps> = ({ onSelect, selectedGroups }) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const { isLoading, data, isError } = useQuery(['groups', companyId], () =>
    getGroups(companyId).then((resp) =>
      resp.data.map((group) => ({
        value: String(group.id),
        label: group.name,
      })),
    ),
  );

  if (isError) {
    showToast(createErrorToast('Could not show API keys due to a server error', 'dev-api-fetch-groups-error-toast'));
    return <div />;
  }

  const options = data || [];
  const selectedIds = selectedGroups.map((g) => String(g.id));

  return (
    <QBox>
      <QMultiSelect
        isLoading={isLoading}
        options={options}
        onChange={(items) => {
          const selected = new Set(items.map((item) => item.value));
          onSelect(
            options.filter((opt) => selected.has(opt.value)).map((opt) => ({ id: Number(opt.value), name: opt.label })),
          );
        }}
        value={selectedIds}
      />
    </QBox>
  );
};
